<ng-container *transloco="let t">
  @let shippingCostResponse = this.shippingCostResponse();

  @if (calculatingShippingCost()) {
    <pxw-shipping-calculation [isFormSubmitted]="isFormSubmitted()" />
  } @else if (shippingCalculationError()) {
    <div class="shipping-error">
      <span>{{ shippingCalculationError() }}</span>
    </div>
  } @else if (shippingCostResponse) {
    @if (isShippingCostResponseDelivery(shippingCostResponse)) {
      <pxw-shipping-cost-response-delivery
        [shippingCostResponse]="shippingCostResponse"
        [isFormSubmitted]="isFormSubmitted()"
        [checkoutData]="checkoutData()"
        [(outOfDeliveryZoneConfirmed)]="outOfDeliveryZoneConfirmed"
      />
    } @else if (isShippingCostResponseParcel(shippingCostResponse)) {
      <pxw-shipping-cost-response-parcel
        [shippingCostResponse]="shippingCostResponse"
        [isFormSubmitted]="isFormSubmitted()"
        [selectedParcelOption]="selectedParcelOption()"
        [apiUrl]="apiUrl()"
        [establishmentId]="establishment().id"
        [postalCode]="address()?.addressDetails?.postalCode || ''"
        [userCoordinates]="userCoordinates()"
        [(outOfDeliveryZoneConfirmed)]="outOfDeliveryZoneConfirmed"
        (selectedParcelOptionChange)="onParcelOptionSelected($event)"
        (selectedBranchChange)="onBranchSelected($event)"
      />
    }
  }
</ng-container>
